module.exports = __webpack_public_path__ + "img/RedMissile-B02-3-250.289c9017.jpg";